import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { DailyPoint } from "@/lib/types";

export function DailyTrendChart({ data }: { data: DailyPoint[] }) {
  if (data.length === 0) {
    return <Empty />;
  }
  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart
        data={data}
        margin={{ top: 8, right: 16, bottom: 0, left: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis dataKey="date" fontSize={11} />
        <YAxis fontSize={11} />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="total" name="총 질의" stroke="#2563eb" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="answered" name="답변" stroke="#16a34a" strokeWidth={1.5} dot={false} />
        <Line type="monotone" dataKey="unanswered" name="미답변" stroke="#dc2626" strokeWidth={1.5} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}

function Empty() {
  return (
    <div className="flex h-[280px] items-center justify-center text-sm text-muted-foreground">
      데이터 없음
    </div>
  );
}
